<template>
  <div class="modal fade update-user-modal" id="UpdateCategoryModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar categoria</h1>
                  <button type="button" class="btn-close update-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdateCategory" @submit.prevent="updateCategoryMethod">
                <div class="modal-body ps-30 pe-30">
                  <div v-if="errorMessage" class="alert alert-danger fs-md-15 fs-lg-16" role="alert">
                    {{ errorMessage }}
                  </div>
                  <p>Preencha as informações abaixo para atualizar a categoria</p>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_category_update" class="form-label fw-medium"
                      >Categoria</label
                    >
                    <input
                      v-model="categoryName"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_category_update"
                      placeholder="Digite a categoria"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <!-- active/inactive flag -->
                  <div class="form-check mb-20 col-12">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="active_category_update"
                      v-model="isActive"
                    />
                    <label class="form-check-label" for="active_category_update">
                      Categoria ativa
                    </label>
                  </div>

                  <div class="mb-20 col-12">
                    <label class="form-label fw-medium">Usuários vinculados</label>

                    <div v-if="availableUsers.length" class="border rounded-2 p-15" style="max-height: 260px; overflow-y: auto;">
                      <div
                        v-for="user in availableUsers"
                        :key="user.id"
                        class="form-check mb-12"
                      >
                        <input
                          :id="`category-user-${user.id}`"
                          v-model="selectedUserIds"
                          :value="user.id"
                          class="form-check-input"
                          type="checkbox"
                        />
                        <label class="form-check-label d-block" :for="`category-user-${user.id}`">
                          <span class="fw-medium text-black-emphasis">{{ user.name }}</span>
                          <small class="d-block text-body-tertiary">{{ user.email || user.phone || 'Sem contato cadastrado' }}</small>
                        </label>
                      </div>
                    </div>

                    <div v-else class="border rounded-2 p-15 text-body-tertiary">
                      Nenhum usuário disponível para vincular.
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="submit" ref="buttonUpdateCategory" class="btn btn-success">Salvar categoria</button>
                  </div>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default defineComponent({
  name: "UpdateCategoryModal",
  computed: {
    ...mapGetters([
      "getCurrentUpdateCategory",
      "getAllUsersList"
    ]),
    availableUsers() {
      const allUsersList = (this as any).getAllUsersList;
      return Array.isArray(allUsersList) ? allUsersList : [];
    }
  },
  data() {
    return {
      categoryName: '',
      isActive: true,
      selectedUserIds: [] as number[],
      errorMessage: ''
    };
  },
  watch: {
    getCurrentUpdateCategory: {
      handler(newVal) {
        if (newVal) {
          this.errorMessage = '';
          this.categoryName = newVal.name;
          this.isActive = (newVal.active === 1 || newVal.active === true || newVal.active === '1');
          this.selectedUserIds = Array.isArray(newVal.users_categories)
            ? newVal.users_categories
                .map((item: { user_id?: number; user?: { id?: number } }) => item.user_id ?? item.user?.id)
                .filter((userId: number | undefined): userId is number => typeof userId === 'number')
            : [];
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      "fetchCategories"
    ]),
    async updateCategoryMethod() {
      const buttonUpdateCategory = this.$refs.buttonUpdateCategory as HTMLButtonElement;
      this.errorMessage = '';
      buttonUpdateCategory.disabled = true;
      buttonUpdateCategory.innerHTML = "Salvando...";

      try {
        const response = await api.axios.put(`/api/category/update/${this.getCurrentUpdateCategory.id}`, {
          name: this.categoryName,
          active: this.isActive,
          user_ids: this.selectedUserIds
        });
        if (response.status === 200) {
          buttonUpdateCategory.innerHTML = "Categoria salva com sucesso!";
          window.location.reload();
        }
      } catch (error) {
        console.error('Erro ao atualizar categoria:', error);
        const backendError = (error as any)?.response?.data;
        this.errorMessage =
          backendError?.message ||
          (typeof backendError === 'string' ? backendError : '') ||
          'Erro ao atualizar categoria.';
        buttonUpdateCategory.disabled = false;
        buttonUpdateCategory.innerHTML = "Salvar";
      }
    }
  }
});
</script>
